<app-dialog-wrapper>
  <app-shipping-method (selectAddress)="onDeliveryMethodChange($event)" />
</app-dialog-wrapper>
